export enum UserLocStore {
  isAuth = 'erpIsAuth',
  id = 'erpId',
  name = 'erpName',
  email = 'erpEmail',
  returnTo = 'erpReturnTo',
}
